export default __webpack_public_path__ + "static/media/alcoholic.93934fc0.png";